export default "__VITE_ASSET__392c8cd5__"